// extracted by css-extract-rspack-plugin
export default {"cls1":"Reader-cls1_UoX","cls2":"Reader-cls2_k3D Reader-cls1_UoX"};